import React from 'react';
import { isEmpty } from 'lodash';
import LoginTextField from '../../elements/editors/mui/LoginTextField';
import { Button } from 'new/elements/Button';

class SSOLoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isInputValid: this._getIsInputValid(props),
    };

    this._handleEmailChanged = this._handleEmailChanged.bind(this);
  }

  componentDidMount() {
    if (this.props.isSSOAutoLogin === true) {
      this.props.logout();

      this.props.onSubmit(null);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.email !== prevProps.email &&
      (this.props.singleStep === true || this.props.showCta === false)
    ) {
      this.setState({
        isInputValid: this._getIsInputValid(this.props),
      });
    }
  }

  render() {
    const { showCta, singleStep } = this.props;

    if (singleStep === false && showCta === true) {
      // not single step, and we are in the general login view
      return (
        <button
          type="button"
          style={{
            marginTop: 20,
            marginBottom: 'var(--spacing-sm)',
            border: '1px solid rgba(38, 94, 219, 0.5)',
            color: 'var(--color-primary-500)',
            fontSize: 'var(--font-size-base)',
            fontWeight: 'var(--font-weight-medium)',
            width: '100%',
            borderRadius: 4,
            backgroundColor: 'white',
            cursor: 'pointer',
            padding: '10px 0',
          }}
          className="signout-button hover"
          onClick={(e) => {
            if (singleStep === true) {
              this.props.onSubmit(e);
            } else {
              this.props.onSSOStateToggle();
            }
          }}
        >
          SSO Login
        </button>
      );
    }

    return (
      <form onSubmit={this.props.onSubmit}>
        <div className="signup-form-item">
          <LoginTextField
            required
            autoFocus
            //type="email"
            label="Email address / Organization ID"
            value={this.props.email ? this.props.email : ''}
            onChange={this._handleEmailChanged}
          />
        </div>
        <Button
          onClick={this.props.onSubmit}
          role="submit"
          variant="contained"
          color="primary"
          style={{ width: '100%' }}
          disabled={!this.state.isInputValid}
        >
          Log In
        </Button>
        <div className="tos-message">
          By signing in you agree to Nexla's{' '}
          <a
            href="https://www.nexla.com/terms-of-service/"
            target="_blank"
            rel="noopener noreferrer"
          >
            terms
          </a>{' '}
          and{' '}
          <a href="https://www.nexla.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
            privacy policy
          </a>
        </div>
        {singleStep === false && (
          <Button
            variant="outlined"
            style={{
              width: '100%',
              marginTop: 20,
              marginBottom: 'var(--spacing-sm)',
            }}
            onClick={() => this.props.onSSOStateToggle()}
          >
            Return to Login Choices
          </Button>
        )}
      </form>
    );
  }

  _handleEmailChanged(event) {
    this.props.onInputChanged('email', event.target.value);
  }

  _getIsInputValid(props) {
    const { email } = props;
    return Boolean(!isEmpty(email));
  }
}

SSOLoginForm.defaultProps = {
  singleStep: false,
  isSSOAutoLogin: false,
  showCta: false,
  onSSOStateToggle: () => {},
};

export default SSOLoginForm;
